/*
 * GA4: 汎用計測（クリック / 表示インプレッション）
 *
 * 要素に class="ga4-event" と data-event="xxx"（接頭辞なし）を付与するだけで、
 * クリック時に click_xxx を、画面内に入った時に view_xxx（1回のみ）をGA4へ自動送信する。
 * バナー・CTAボタン・カード・モーダル等、用途を問わず使い回せる汎用の仕組み。
 * 他サイトへの移植を考慮し、jQuery非依存（Vanilla JS）で実装している。
 *
 * イベント名は「行為」だけを表す汎用名にし、ページの切り分けはGA4が自動収集する
 * ページ情報（Explore等でのページパス別内訳）に任せる。ページ名を含めた
 * イベント名（例: lead_form_spacerental）は作らないこと（LPが増えるたびに
 * イベント名とキーイベント登録が増殖してしまうため）。
 *
 * 使い方:
 *   <a class="ga4-event button" href="https://forms.gle/xxxx" target="_blank"
 *      data-event="lead_form"
 *      data-button_id="spacerental_hero_cta"
 *      data-section="hero">ご予約はこちら</a>
 *
 *   → クリック時: click_lead_form
 *   → 表示時:     view_lead_form
 *
 * 自動取得される値（data-*での指定不要、data-*があればそちらを優先）:
 *   - destination_url: <a href="..."> があれば自動取得
 *   - label:           要素のテキスト（el.textContent）を自動取得
 *                       ※画像やカードなど入れ子構造で中身が複雑な要素は
 *                         textContentが読めない文字列になるため data-label で明示指定する
 *
 * 注意: data-* 属性はアンダースコア区切りで書くこと（data-button_id）。
 *       ハイフン区切り（data-button-id）だとdatasetがcamelCaseに変換し、
 *       下記 allowedKeys の "button_id" と一致しなくなる。
 *
 * パラメータを追加したい場合は allowedKeys にキー名を追記する。
 */
document.addEventListener('DOMContentLoaded', function () {

  const SELECTOR = '.ga4-event';
  const LABEL_MAX_LENGTH = 100; // GA4のイベントパラメータ値は100文字が上限

  // ホワイトリスト：送信対象とする data-* 属性のキー
  const allowedKeys = [
    // 共通パラメータ（すべてのイベントで使用可能）
    'label',              // 表示テキスト（未指定ならtextContentから自動取得）
    'section',            // ページ内のセクション名（例：hero, footer）
    'index',              // 要素の順番（例：1番目のカード）
    'container_index',
    'destination_url',    // 遷移先URL（<a>なら未指定時にhrefから自動取得）

    // 投稿カード用パラメータ
    'post_id',
    'post_title',         // カード内の入れ子構造でtextContentが使えないため個別に保持

    // バナー・ボタン用パラメータ
    'banner_id',
    'button_id',
  ];

  function sendGA4Event(el, options = {}) {
    const baseEventName = el.dataset.event;
    if (!baseEventName) return;

    const prefix = options.type === 'view' ? 'view_' : 'click_';
    const eventName = prefix + baseEventName;

    const params = {};
    allowedKeys.forEach(function (key) {
      const val = el.dataset[key];
      if (val !== undefined && val !== '') {
        params[key] = val;
      }
    });

    // href を持つ要素は destination_url を自動取得（data-destination_url があれば上書き優先）
    if (!params.destination_url && el.href) {
      params.destination_url = el.href;
    }

    // 表示テキストを label として自動取得（data-label があれば上書き優先）
    if (!params.label) {
      const text = el.textContent.trim();
      if (text) params.label = text.slice(0, LABEL_MAX_LENGTH);
    }

    if (typeof gtag !== 'function') return;
    gtag('event', eventName, params);
  }

  // クリック計測（イベント委譲：後から追加された要素にも自動対応）
  document.addEventListener('click', function (e) {
    const el = e.target.closest(SELECTOR);
    if (el) sendGA4Event(el);
  });

  // 表示（インプレッション）計測：画面内に入った時点で1回だけ送信
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;

      sendGA4Event(entry.target, { type: 'view' });
      observer.unobserve(entry.target);
    });
  }, {
    root: null,
    rootMargin: '0px',
    threshold: 0,
  });

  document.querySelectorAll(SELECTOR).forEach(function (el) {
    observer.observe(el);
  });

});
